import { NgModule, DoBootstrap, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { PtlXhrModule } from '@ptl/xhr';
import { MaterialGlobalModule } from 'src/app/shared/modules/material-global.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgReduxFormConnectModule, NgReduxFormConnectArrayModule } from '@ptl/angular-redux-form';
import { NgReduxModule } from '@ptl/angular-redux-store';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { ReducersRegistryModule } from 'src/app/shared/modules/reducers-registry.module';
import { ConsumerApplicationStatusComponent } from './components/consumer-application-status/consumer-application-status.component';
import { ConsumerEligibilityStatusComponent } from './components/consumer-eligibility-status/consumer-eligibility-status.component';
import { GoToMarketplaceModalComponent } from './components/consumer-application-status/go-to-marketplace-modal/go-to-marketplace-modal.component';
import { MoreInfoModalComponent } from './components/consumer-application-status/more-info-modal/more-info-modal.component';
import { ApplicationCardOnExchangeComponent } from './components/consumer-application-status/application-card-on-exchange/application-card-on-exchange.component';
import { NewQuoteOnExchangeComponent } from './components/consumer-application-status/new-quote-on-exchange/new-quote-on-exchange.component';
import { ProducerProspectPaginatorPipe } from './pipes/producer-prospect-paginator.pipe';
import { ProducerProspectPaginatorComponent } from './components/consumer-application-status/producer-prospect-paginator/producer-prospect-paginator.component';
import { StateModuleReadyService } from '@ptl/state';
@NgModule({
  declarations: [
    ConsumerApplicationStatusComponent,
    ConsumerEligibilityStatusComponent,
    GoToMarketplaceModalComponent,
    MoreInfoModalComponent,
    ApplicationCardOnExchangeComponent,
    NewQuoteOnExchangeComponent,
    ProducerProspectPaginatorPipe,
    ProducerProspectPaginatorComponent
  ],
  imports: [
    CommonModule,
    MaterialGlobalModule,
    FormsModule,
    ReactiveFormsModule,
    NgReduxModule,
    NgReduxFormConnectModule,
    NgReduxFormConnectArrayModule,
    PtlXhrModule,
    SharedComponentsModule,
    ReducersRegistryModule
  ],
  exports: [
    ConsumerApplicationStatusComponent,
    ConsumerEligibilityStatusComponent,
    GoToMarketplaceModalComponent,
    MoreInfoModalComponent
  ],
  providers: [CurrencyPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})


export class OnExchangeModule implements DoBootstrap {

  constructor(
    private injector: Injector,
    private stateModuleReadyService: StateModuleReadyService
  ) {
    // console.log("OnExchangeModule - constructor");
    this.stateModuleReadyService.ready$.subscribe((isReady: boolean) => {
      if (isReady) {
        this.createElementIfDoesNotExist('sxe-consumer-application-status', ConsumerApplicationStatusComponent);
        this.createElementIfDoesNotExist('sxe-consumer-eligibility-status', ConsumerEligibilityStatusComponent);
      }
    });
  }

  /** Adding these checks in, as during debugging, sometimes the error of previous definition would be thrown */
  createElementIfDoesNotExist(elementName: string, elementComponent: any) {
    if (!customElements.get(elementName)) {
      const customElement = createCustomElement(elementComponent, { injector: this.injector });
      customElements.define(elementName, customElement);
    }
  }

  // https://github.com/angular/angular/issues/31135
  // Necessary to not get errors associated w/ attachShadow to Angular Element
  ngDoBootstrap() { }
}
